import { AddBox, MoreVert } from '@mui/icons-material';
import { Box, Button, Checkbox, IconButton, Stack } from '@mui/material';
import ganttStore from 'components/projectOverview/gantt/ganttConfig/ganttStore';
import { addDays } from 'date-fns';
import { useState } from 'react';
import TaskContextMenu from './TaskContextMenu';

export const ActionColumnCell = ({ task, ganttId }) => {
  const gantt = ganttStore.getGantt(ganttId);
  const isTaskSelected = gantt.isSelectedTask(task.id);
  const isReadonly = gantt.config.readonly || (task.readonly && task.type !== 'project_bar');

  const [contextMenuAnchor, setContextMenuAnchor] = useState(undefined);

  const handleAddChild = () => {
    task.$open = true;
    const newTaskId = gantt.addTask(
      {
        text: 'Create New Task',
        start_date: task.start_date,
        end_date: addDays(task.start_date, 1),
        location_id: task.location_id,
        zone_id: task.zone_id,
        area_id: task.area_id,
        project_id: task.project_id,
        display_order: task.display_order + 1,
      },
      task.id,
      0
    );
    gantt.showTask(newTaskId);
    gantt.selectTask(newTaskId);
  };

  const handleToggleAutoScheduleDate = () => {
    if (task.autoschedule_date === 'forecasted') {
      task.autoschedule_date = 'schedule';
    } else {
      task.autoschedule_date = 'forecasted';
    }
    task.end_date =
      task.autoschedule_date === 'schedule' ? task.scheduled_end_date : task.forecasted_end_date;
    gantt.updateTask(task.id);
    gantt.autoSchedule(task.id);
  };

  return (
    <Stack alignItems={'center'} data-task-id={task.id} direction={'row'} width={'100%'}>
      <IconButton
        size={'small'}
        sx={{ p: 0.2 }}
        onClick={(e) => {
          e.stopPropagation();
          setContextMenuAnchor(e.currentTarget);
        }}
      >
        <MoreVert fontSize={'inherit'} />
      </IconButton>
      {contextMenuAnchor && (
        <TaskContextMenu
          anchor={contextMenuAnchor}
          ganttId={ganttId}
          handleClose={() => setContextMenuAnchor(undefined)}
          id={task.id}
        />
      )}
      {task.id > 0 && (
        <Checkbox
          checked={isTaskSelected}
          id={`checkbox-${task.id}`}
          size={'small'}
          sx={{ p: 0.2 }}
        />
      )}
      <Box mr={'auto'} />
      {
        task.id > 0 /* <Tooltip arrow placement={'top'} title={'Settings'}> */ && (
          <Button
            className={'toggle_autoschedule_date'}
            color={task.autoschedule_date === 'forecasted' ? 'primary' : 'secondary'}
            disabled={isReadonly}
            size={'small'}
            sx={{ p: 0.2, minWidth: 0 }}
            onClick={handleToggleAutoScheduleDate}
          >
            {task.autoschedule_date === 'forecasted' ? 'F' : 'S'}
          </Button>
        )
        /* </Tooltip> */
      }
      {/* <Tooltip arrow placement={'top'} title={'Add Child'}> */}
      <IconButton
        className={'insert_child'}
        color={'primary'}
        disabled={isReadonly}
        size={'small'}
        sx={{ p: 0.5 }}
        onClick={handleAddChild}
      >
        <AddBox />
      </IconButton>
      {/* </Tooltip> */}
    </Stack>
  );
};
